module.exports = __webpack_public_path__ + "img/bgIcon_10.4025bc4a.png";